import { isValidElement } from "react";

import { Button } from "@components/Button";
import { ButtonType } from "@components/Button/types";
import { BottomButtonProps } from "@components/OnboardingLayout";
import { Spacing, SpacingSizes } from "@components/Spacing";
import { Body, H1 } from "@components/Typography";
import { spacing } from "@layout";
import { Container, useStyles } from "./styles";
import { OverlayProps } from "./types";

export const Overlay = ({
  title,
  subtitle,
  cta: ctaProp,
  children,
  header,
  footer,
  horizontal = false,
  scrollable = false,
  wide = false,
}: OverlayProps) => {
  const styles = useStyles();

  const cta = (() => {
    if (!ctaProp) return null;
    if (isValidElement(ctaProp)) return ctaProp;

    const buttonContainerStyle = horizontal ? styles.horizontal : undefined;

    const { primary, secondary } = ctaProp as BottomButtonProps;

    if (!primary && !secondary) return null;

    return (
      <div style={buttonContainerStyle}>
        <Spacing size={SpacingSizes.XXS} />
        {primary ? <Button {...primary} /> : null}

        {horizontal ? <div style={{ width: spacing.s }} /> : null}

        {secondary ? (
          <>
            <Spacing size={SpacingSizes.XS} />
            <Button type={ButtonType.Secondary} {...secondary} buttonStyle={styles.secondary} />
          </>
        ) : null}
      </div>
    );
  })();

  return (
    <Container scrollable={scrollable} wide={wide}>
      {header}

      {title ? (
        <>
          <H1>{title}</H1>
          <Spacing size={SpacingSizes.M} />
        </>
      ) : null}

      {subtitle ? (
        <>
          <Body>{subtitle}</Body>
          <Spacing size={SpacingSizes.M} />
        </>
      ) : null}

      {footer ? (
        <>
          {footer}
          <Spacing size={SpacingSizes.M} />
        </>
      ) : null}

      {scrollable ? (
        <>
          <div style={{ flex: 1, overflowY: "auto" }}>{children}</div>
          {cta && <div style={{ flexShrink: 0, marginTop: "auto" }}>{cta}</div>}
        </>
      ) : (
        <>
          {children}
          {cta}
        </>
      )}
    </Container>
  );
};
